/**
 * Windows 11対応のお知らせページ
 */
import { WindowsSupported } from "../components/WindowsSupportedStart";

/**
 *
 * @returns Windows 11対応のお知らせページのJSX Element
 */
export const Windows11Supported: React.FC = () => {
  const items = [
    {
      to: "/cmcd-200#systemRequirements",
      text: "動作環境",
    },
  ];

  return <WindowsSupported os="Windows 11" softName="CMCD-200ソフトウェア" items={items} />;
};
